export default __webpack_public_path__ + "static/media/btn_moodGood.bbe8b815.png";